'use client';

import React from 'react';

import {
    Alignable,
    Box,
    Column,
    Columns,
    Icon,
    IconName,
    IconSize,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';

type TradeInBillLineProps = {
    icon?: IconName;
    amount: number;
    label: string;
    isOverlined?: boolean;
    classNameIcon?: string;
    isFullwidth?: boolean;
    isMobile?: boolean;
};

export function TradeInBillLine({ icon, amount, label, isOverlined }: TradeInBillLineProps) {
    return (
        <Columns verticalAlign={Alignable.ALIGNED_CENTER} mobile>
            {icon && (
                <Column>
                    <Icon name={icon} size={IconSize.SMALL} />
                </Column>
            )}
            <Column tabletSize={icon ? 9 : 12}>
                <Box backgroundColor={isOverlined ? TrilogyColor.INFO_FADE : TrilogyColor.BACKGROUND} shadowless>
                    <Text typo={isOverlined ? TypographyBold.TEXT_WEIGHT_SEMIBOLD : undefined} level={TextLevels.TWO}>
                        {label}
                    </Text>
                    <InlinePrice amount={amount} />
                </Box>
            </Column>
        </Columns>
    );
}

export function TradeInBillLineMobile({ icon, amount, label, isOverlined, isFullwidth }: TradeInBillLineProps) {
    return (
        <Columns verticalAlign={Alignable.ALIGNED_CENTER} mobile>
            {!isFullwidth && <Column mobileSize={2}>{icon && <Icon name={icon} size={IconSize.SMALL} />}</Column>}
            <Column>
                <Box
                    backgroundColor={isOverlined ? TrilogyColor.INFO_FADE : TrilogyColor.BACKGROUND}
                    shadowless
                    className='is-paddingless'
                >
                    <Columns verticalAlign={Alignable.ALIGNED_CENTER} mobile marginless className='p-small'>
                        <Column>
                            <Text typo={isOverlined ? TypographyBold.TEXT_WEIGHT_SEMIBOLD : undefined} marginless>
                                {label}
                            </Text>
                        </Column>
                        <Column narrow>
                            <InlinePrice amount={amount} />
                        </Column>
                    </Columns>
                </Box>
            </Column>
        </Columns>
    );
}
